import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from './components/pages/Home';
import About from './components/pages/About';
import Projects from './components/pages/Projects';
import NavBar from './components/NavigationBar';
import WorkExperience from './components/pages/WorkExperience';

function App() {
  return (
    <Router>
      <NavBar/>
      <Routes>
        <Route path="/" element={Home()} />
        <Route path="/about" element={About()} />
        <Route path="/projects" element={Projects()} />
        <Route path="/WorkExperience" element={WorkExperience()} />
      </Routes>
    </Router>
  );
}

export default App;
